import { skipToken } from '@reduxjs/toolkit/query/react';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { Modals } from '@/constants';
import {
  selectActiveModal,
  selectSessionUserId,
  uiActions,
  useAppDispatch,
  useShowProductFeedbackQuery,
} from '@/store';

// Prompt user for feedback (if eligible) after a timer expires
const FEEDBACK_PROMPT_TIMER = 1000 * 60 * 3; // 3 minutes

export const useDisplayProductFeedbackModal = () => {
  const activeModal = useSelector(selectActiveModal);
  const dispatch = useAppDispatch();

  const timeoutRef = useRef<NodeJS.Timeout>(null);
  const isShown = useRef(false);

  const userId = useSelector(selectSessionUserId);

  const { data: showProductFeedback } = useShowProductFeedbackQuery(
    userId ? undefined : skipToken,
  );

  const shouldShowProductFeedbackModal = showProductFeedback && !activeModal;

  useEffect(() => {
    if (isShown.current) return;

    const showProductFeedback = () => {
      isShown.current = true;
      dispatch(uiActions.setActiveModal({ name: Modals.PRODUCT_FEEDBACK }));
    };

    if (shouldShowProductFeedbackModal) {
      timeoutRef.current = setTimeout(
        showProductFeedback,
        FEEDBACK_PROMPT_TIMER,
      );
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [shouldShowProductFeedbackModal, dispatch]);
};
